import { render, staticRenderFns } from "./answer_question.vue?vue&type=template&id=74809767&scoped=true"
import script from "./answer_question.vue?vue&type=script&lang=js"
export * from "./answer_question.vue?vue&type=script&lang=js"
import style0 from "./answer_question.vue?vue&type=style&index=0&id=74809767&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74809767",
  null
  
)

export default component.exports